import React from "react";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";
import { Button, Icon, Popover, Typography } from "@bca/ui-library";
import css from "@styled-system/css";

import CreateStockAlertButton from "./CreateStockAlertButton";
import PrintAllButton from "./PrintAllButton";
import ExportAllButton from "./ExportAllButton";
import { Links } from "../vehicle-search-details/vehicleSearch.type";
import { StoreType } from "../StoreType";
import { TRACKED } from "../constants";
import { GET_STATE } from "../redux/slices/appSlice";

const EllipsisPopover: React.FunctionComponent<{
  createStockAlertLink: string;
  printAllLink: Links;
  exportAllLink: Links;
  pdfEnabled?: boolean;
}> = ({ createStockAlertLink, printAllLink, exportAllLink, pdfEnabled }) => {
  const router = useRouter();
  const { requestOrigin } = router.query;
  const isTrackedPage = requestOrigin === TRACKED;

  const {
    app: { isPrintServiceUnavailable },
  }: StoreType = useSelector(GET_STATE);

  const maxLimitMessage = isTrackedPage
    ? "You can only print a maximum of 1,000 vehicles."
    : "You can only print or export a maximum of 1,000 vehicles.";

  const button = (
    <Button
      data-testid="ellipsis-button"
      width="48px"
      height="48px"
      ml="10px"
      p="0"
      variant={isPrintServiceUnavailable ? "button" : "tertiary"}
      css={`
        &[aria-expanded="false"] {
          ${css({
            path: {
              fill: "primary-light-blue",
            },
            borderRadius: 8,
            border: "normalBorder",
            boxShadow: "default",
            backgroundColor: "primary-white",
          })}
        }
        &:hover,
        &[aria-expanded="true"] {
          ${css({
            path: {
              fill: "white",
            },
            backgroundColor: "primary-light-blue",
            border: "none",
          })}
        }
      `}
    >
      <Icon
        width="18px"
        height="18px"
        name="ellipsis-h"
        weight="regular"
        color="primary-light-blue"
      />
    </Button>
  );

  return (
    <>
      {isPrintServiceUnavailable ? (
        button
      ) : (
        <Popover
          width="260px"
          height="auto"
          paddingX={6}
          paddingY={6}
          zIndex={2}
        >
          {button}
          <ul
            style={{
              listStyle: "none",
              margin: 0,
              padding: 0,
            }}
          >
            {!isTrackedPage && (
              <>
                <li>
                  <CreateStockAlertButton
                    createStockAlertLink={createStockAlertLink}
                  />
                </li>
                <li>
                  <ExportAllButton
                    exportAllLink={exportAllLink}
                    pdfEnabled={pdfEnabled}
                  />
                </li>
              </>
            )}
            <li>
              <PrintAllButton
                printAllLink={printAllLink}
                pdfEnabled={pdfEnabled}
              />
            </li>
            {!Boolean(printAllLink?.href) && !Boolean(exportAllLink?.href) && (
              <li>
                <Typography variant="body" color="grey-blue" my={0} mt={2}>
                  {maxLimitMessage}
                </Typography>
              </li>
            )}
          </ul>
        </Popover>
      )}
    </>
  );
};

export default EllipsisPopover;
